import { Component } from 'opus-angular-seed-core';

@Component({
    template: '<timepicker ng-model="vm.dateModel" ng-change="vm.onDateChange()" ng-disabled="vm.ngDisabled"></timepicker>',
    bindings: {
        ngModel: '=',
        ngChange: '&',
        ngDisabled: '='
    }
})
export default class {
    constructor ($timeout, $scope, moment) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.moment = moment;
        $scope.Math = window.Math;
        $scope.$watch('vm.ngModel', () => {
            if (this.ngModel) {
                let minutes = this.$scope.Math.floor(this.ngModel / 60);
                // const secs = this.ngModel % 60;
                const hours = this.$scope.Math.floor(minutes / 60);
                minutes = minutes % 60;

                const date = new Date();
                date.setHours(parseInt(hours, 10));
                date.setMinutes(parseInt(minutes, 10));
                // component which is used to select time, does not have seconds input, therefore seconds is always 0
                date.setSeconds(0);

                this.dateModel = moment(date);
            }
            else {
                // set model to be null in the beginning for placeholder to appear
                this.dateModel = null;
            }
        });
    }

    onDateChange () {
        this.$timeout(() => {
            // return a value as seconds but do not include timepicker seconds because our timepicker only supports HH:mm
            this.ngModel = this.moment.duration(this.moment(this.dateModel).format('HH:mm:00'), 'HH:mm:ss').asSeconds();
            if (this.ngChange) {
                this.ngChange();
            }
        }, 1000);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/timepicker/api/index.js